import { isUuid } from '@/lib/validation';
import type { ServiceClient } from '../http/client';
import { ApiError } from '../http/errors';
export interface ClueDeviceWrite {
  command_id: string;
  device_id: string;
  provider: 'CLUE';
  is_active: boolean;
  purpose: 'COMMON_ENTRANCE' | 'ELEVATOR' | 'SPACE' | 'MODULE';
  floor: number | null;
  elevator_floors: number[] | null;
  device_name?: string | null;
  expected_revision?: number;
}
/** 기기 UUID와 명령 UUID를 구분하며 Clue 등록에는 gateway가 없다. */
export async function saveClueDevice(
  client: ServiceClient,
  propertyId: string,
  id: string | null,
  body: ClueDeviceWrite,
): Promise<{ core_device_id: string; revision: number }> {
  const path = `admin/properties/${propertyId}/access-devices${id ? `/${id}` : ''}`;
  const result = id
    ? await client.put<unknown>(path, { json: body })
    : await client.post<unknown>(path, { json: body });
  const x = result as {
    command_id?: unknown;
    core_device_id?: unknown;
    revision?: unknown;
    effect?: unknown;
    device?: {
      core_device_id?: unknown;
      provider?: unknown;
      gateway_id?: unknown;
      revision?: unknown;
    };
  } | null;
  if (
    x?.command_id !== body.command_id ||
    typeof x.core_device_id !== 'string' ||
    !isUuid(x.core_device_id) ||
    (id && x.core_device_id !== id) ||
    !Number.isSafeInteger(x.revision) ||
    Number(x.revision) < 1 ||
    !['CHANGED', 'NO_CHANGE'].includes(String(x.effect)) ||
    x.device?.provider !== 'CLUE' ||
    x.device.gateway_id !== null ||
    x.device.core_device_id !== x.core_device_id ||
    x.device.revision !== x.revision
  )
    throw new ApiError({
      kind: 'invalid-response',
      service: 'core',
      message: 'Clue 기기 결과를 확인할 수 없습니다.',
    });
  return { core_device_id: x.core_device_id, revision: Number(x.revision) };
}
